import { reducerActions, sagaActions } from './cartConsts';
import { actions } from '../common/fedOps/fedOpsConsts';

export function changeItemPurchaseAttributes(item, license, quality) {
  return {
    type: sagaActions.changeItemPurchaseAttributes,
    payload: {
      item,
      license,
      quality
    }
  };
}

export function removeCartItem(item) {
  return {
    type: sagaActions.removeCartItem,
    payload: item
  };
}

export function checkout(cartItems) {
  return {
    type: sagaActions.checkout,
    payload: cartItems
  };
}

export function goToCheckout(_payload) {
  return {
    type: sagaActions.goToCheckout,
    payload: _payload || {},
  };
}

export function mainAppLoaded() {
  return {
    type: actions.mainAppLoaded
  }
}
